import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import { PrimaryButton } from "../components/buttons/primaryButton/PrimaryButton.tsx";

export default function ConfirmModal({ isOpen, onClose, onConfirm, message }) {
  const { t } = useTranslation();

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="appointment-page modal-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="appointment-page modal confirm-modal-appointment"
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
          >
            <div className="appointment-page modal-header">
              <h2>{t("confirm")}</h2>
            </div>

            <div className="appointment-page modal-body w-[365px]">
              <p>{message}</p>
            </div>

            <div className="appointment-page modal-footer">
              <PrimaryButton
                onClick={onClose}
                label={t("cancel")}
                variant="ghost"
              />
              <PrimaryButton
                onClick={onConfirm}
                label={t("confirm")}
              />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}